import { createStyles } from '@mui/styles';
import type { StyleRules } from '@mui/styles/withStyles';

const styles = (): StyleRules => createStyles({
  container: {
  },
  icon: {
    marginLeft: '.5rem',
  },
});

export { styles };
